









import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'OfferAlertBar'
    props: ['offers']
    components: { AlertBar }
    data: ->
      acceptableOffer: null
      termsOffer: null
    methods: 
      alert: () ->
        return @promptToTermsAlert(@termsOffer) if @termsOffer
        return @promptToAcceptAlert(@acceptableOffer) if @acceptableOffer
        return null
      promptToAcceptAlert: (offer) ->
        {
          id: offer.id
          type: 'cta'
          message: "You can now accept the offer for #{@formatTitleForOffer(offer)}."
          button: { label: 'View Offer', nav: { name: 'OfferShowPage', params: { offerId: offer.id } } } 
          dismissable: false
        }
      promptToTermsAlert: (offer) ->
        {
          id: offer.id
          type: 'info'
          message: "Congratulations! You've received an offer for #{@formatTitleForOffer(offer)}. Please agree to the terms, if it is a good fit."
          button: { label: 'View Offer', nav: { name: 'OfferShowPage', params: { offerId: offer.id } } } 
          dismissable: false
        }
      termsAcceptedForOffer: (offer) -> 
        accepted = true
        accepted = (accepted and agreement.accepted) for key, agreement of offer.offer_acceptance_agreement
        accepted
      formatTitleForOffer: (offer) ->
        audienceListing = @ctxAudienceListing(offer)
        vendorListing = @ctxVendorListing(offer)
        listing = audienceListing if audienceListing.id
        listing ||= vendorListing if vendorListing.id
        @$options.filters.formatListingTitle listing
    mounted: ->
      @acceptableOffer ||= o for o in @offers when @termsAcceptedForOffer(o) and o.pending
      @termsOffer ||= o for o in @offers when !@termsAcceptedForOffer(o)

export default VueOptions.vue settings
